<template>
  <header
    v-if="!hideTitle || !hideNewTaskButton"
    class="mb-4 d-flex justify-content-between align-items-center"
  >
    <span
      v-if="!hideTitle"
      :class="[
        'mb-0',
        {
          'h4': variant !== 'narrow',
          'h5': variant === 'narrow'
        }
      ]"
    >
      <i :class="`fa fa-fw mx-1 ${icon} ${iconColorClass}`"></i>
      {{ title }}
    </span>
    <button
      v-if="!hideNewTaskButton"
      class="btn btn-link text-body text-decoration-none"
      @click.prevent="createNewTask()"
    >
      <i class="fa fa-plus mr-1"></i>
      New Task
    </button>
  </header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default'
    },
    icon: {
      type: String,
      default: 'fa-check'
    },
    iconColorClass: {
      type: String,
      default: ''
    },
    hideNewTaskButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    createNewTask () {
      this.$emit('createNewTask')
    }
  }
}
</script>
